export enum PlatformInvitationType {
  JOB = 'job',
  TALENTHUB = 'talenthub',
}
